import React, { useState, useEffect } from 'react';
import './EmptyGalleryGuide.css';

const EmptyGalleryGuide = ({ 
  isVisible, 
  isViewMode, 
  assetsCount = 0,
  onComplete 
}) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [isActive, setIsActive] = useState(false);

  // Reset when visibility changes
  useEffect(() => {
    if (isVisible && assetsCount === 0) {
      setIsActive(true);
      // Check if already in edit mode, if so skip to step 1
      setCurrentStep(isViewMode ? 0 : 1);
    } else {
      setIsActive(false);
    }
  }, [isVisible, assetsCount, isViewMode]);

  // Auto-advance when user presses V (enters edit mode)
  useEffect(() => {
    if (isActive && currentStep === 0 && !isViewMode) {
      // User pressed V and is now in edit mode, show the spots step
      setCurrentStep(1);
    }
  }, [isViewMode, isActive, currentStep]);

  // Complete tour when first asset is added
  useEffect(() => {
    if (assetsCount > 0) {
      setIsActive(false);
      if (onComplete) {
        onComplete();
      }
    }
  }, [assetsCount, onComplete]);

  if (!isActive) {
    return null;
  }

  const steps = [
    {
      id: 'press-v',
      title: 'Toggle Edit Mode',
      content: 'Press V to toggle between view and edit mode',
      position: 'wallet-tab'
    },
    {
      id: 'find-spots',
      title: 'Add Your NFTs',
      content: 'Look for plus signs on the walls like this to add your NFTs',
      position: 'center',
      showIcon: true
    }
  ];

  const step = steps[currentStep];
  if (!step) return null;

  const handleDismiss = () => {
    setIsActive(false);
    if (onComplete) {
      onComplete();
    }
  };

  return (
    <>
      {/* Subtle overlay */}
      <div className="empty-gallery-overlay" />
      
      {/* Guide tooltip */}
      <div className={`empty-gallery-guide ${step.position}`}>
        <div className="guide-card">
          <div className="guide-header">
            <h3 className="guide-title">{step.title}</h3>
            <button 
              className="guide-close"
              onClick={handleDismiss}
              aria-label="Skip guide"
            >
              ×
            </button>
          </div>
          
          <div className="guide-content">
            <p>{step.content}</p>
            
            {step.showIcon && (
              <div className="plus-sign-illustration">
                <div className="plus-box">
                  <span className="plus-icon">+</span>
                </div>
              </div>
            )}
          </div>
          
          <div className="guide-footer">
            <div className="guide-step-indicator">
              {currentStep === 0 ? 'First:' : 'Next:'}
            </div>
            
            {currentStep === 1 && (
              <button 
                className="guide-btn"
                onClick={handleDismiss}
              >
                Got it!
              </button>
            )}
          </div>
        </div>
        
        {/* Pointer arrow */}
        <div className="guide-arrow" />
      </div>
    </>
  );
};

export default EmptyGalleryGuide;